import { useTranslation } from 'react-i18next';
import { Button, Badge } from 'reactstrap';

export interface PickListSignoffBarProps {
  status: string;
  canMutate: boolean;
  /**
   * SP-10: la conferma manuale è ammessa SOLO per liste con righe parziali.
   * Una lista evasa completa (hasPartials=false) viene inviata e auto-confermata
   * dall'ERP → niente tasto Conferma, badge "Evasa completa".
   */
  hasPartials: boolean;
  confirmedAt: string | null;
  confirmedByEmail: string | null;
  onConferma: () => void;
  onRiapri: () => void;
}

export function PickListSignoffBar({
  status, canMutate, hasPartials, confirmedAt, confirmedByEmail, onConferma,
}: PickListSignoffBarProps) {
  const { t, i18n } = useTranslation('picklist');
  if (status !== 'fulfilled' && status !== 'confirmed') return null;
  const dateLocale = i18n.language === 'en' ? 'en-GB' : 'it-IT';
  return (
    <div className="d-flex align-items-center gap-3 mb-3 p-2 rounded border bg-body-tertiary">
      {status === 'fulfilled' && hasPartials && (
        <>
          <Badge color="warning" className="bg-warning-subtle text-warning">{t('signoff.pending_label')}</Badge>
          {canMutate && (
            <Button color="success" size="sm" onClick={onConferma}
                    title={t('signoff.confirm_tooltip')}>
              {t('signoff.confirm_short')}
            </Button>
          )}
        </>
      )}
      {status === 'fulfilled' && !hasPartials && (
        <>
          <Badge color="success" className="bg-success-subtle text-success">{t('signoff.evaso_label')}</Badge>
          <span className="text-muted small">
            <i className="bi bi-cloud-arrow-up me-1" />
            {t('signoff.evaso_hint')}
          </span>
        </>
      )}
      {status === 'confirmed' && (
        <>
          <Badge color="success" className="bg-success-subtle text-success">{t('signoff.confirmed_label')}</Badge>
          {/* bug_fixes_tpicking_development — una pick-list CONFERMATA è terminale:
              niente più tasto "Riapri" (la conferma non è reversibile). */}
          <span className="text-muted small">
            {confirmedByEmail ? `${t('signoff.by_email', { email: confirmedByEmail })} ` : ''}
            {confirmedAt ? t('signoff.on_date', { date: new Date(confirmedAt).toLocaleDateString(dateLocale) }) : ''}
          </span>
        </>
      )}
    </div>
  );
}
